import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment';

/**
 * Logger service that handles environment-specific logging
 * - Development: all log levels (debug, info, warn, error)
 * - Production: only warnings and errors
 */
@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private isBrowser: boolean;
  private isProduction: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.isProduction = environment.production;
  }

  /**
   * Log debug message (only in development)
   */
  debug(message: any, ...optionalParams: any[]): void {
    if (!this.isProduction && this.isBrowser) {
      console.debug(message, ...optionalParams);
    }
  }

  /**
   * Log info message (only in development)
   */
  info(message: any, ...optionalParams: any[]): void {
    if (!this.isProduction && this.isBrowser) {
      console.info(message, ...optionalParams);
    }
  }

  /**
   * Log warning message (development and production)
   */
  warn(message: any, ...optionalParams: any[]): void {
    console.warn(message, ...optionalParams);
  }

  /**
   * Log error message (development and production)
   */
  error(message: any, ...optionalParams: any[]): void {
    console.error(message, ...optionalParams);
  }

  /**
   * Log event tracking (only in development)
   */
  trackEvent(eventName: string, params?: Record<string, any>): void {
    if (!this.isProduction && this.isBrowser) {
      console.log(`[Event] ${eventName}`, params || '');
    }
  }
}
